export const MODULE_FILES = 'files';
export const MODULE_FEATURE_OPTIONS = 'feature_options';
export const MODULE_COMPANIES = 'companies';

export default {
  MODULE_FILES,
  MODULE_FEATURE_OPTIONS,
  MODULE_COMPANIES,
};
